import { useState } from 'react';
import { Auth } from 'aws-amplify';
import { ValidateEmail } from '../../../shared/AccountPolicy/AccountPolicy';
import sharedHistory from '../../../shared/History';
import { withNavBar } from '../../shared/NavBar/NavBar';
import useLocalization from '../../../shared/useLocalization/useLocalization';

import './ForgotPassword.scss';
import { RouteNames } from '../../../shared/enums/RouteNames';

export const FormIds = {
  resetBtn: 'resetButton',
  emailInp: 'Email',
  cancelBtn: 'Cancel',
  resetWithCodeBtn: 'resetWithCodeBtn',
  mainTitle: 'mainTitle',
};

const VALID = 'valid';

const ForgotPassword = () => {
  const local = useLocalization();
  const [resetPasswordErrorMessage, setResetPasswordErrorMessage] =
    useState('');
  const [formValid, setFormValid] = useState(false);
  const [email, setEmail] = useState('');
  const [emailValidation, setEmailValidation] = useState(
    {} as IFieldValidation
  );

  const resetPassword = async (event: any) => {
    event.preventDefault();
    if (local) {
      //local will always be true here but... TypeScript
      try {
        const origin = window.location.origin;
        const resetLink = origin.toString().includes('localhost') ?  `${origin}${RouteNames.ForgotPasswordCode}` 
        : `${window.location.href.substring(0, window.location.href.lastIndexOf('/'))}${RouteNames.ForgotPasswordCode}`

        await Auth.forgotPassword(email, {
          resetPage: `${resetLink}`,
          emailSubjectText: local.t('forgotPassword.emailSubjectText'),
          emailResetCodeText: local.t('forgotPassword.emailResetCodeText'),
          emailLinkText: local.t('forgotPassword.emailLinkText'),
        });
        setResetPasswordErrorMessage('');
        sharedHistory.push(`${RouteNames.ForgotPasswordSuccess}?u=${email}`);
      } catch (e) {
        setResetPasswordErrorMessage(local.t('forgotPassword.resetError'));
        console.error(e);
      }
    }
  };

  const validateEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue: string = event.currentTarget.value.trim();
    const validate = ValidateEmail(newValue);
    setEmail(newValue);
    setEmailValidation(validate);
    setFormValid(validate.class === VALID);
  };

  const sendToPasswordResetWithCode = () => {
    sharedHistory.push(RouteNames.ForgotPasswordCode);
  };

  if (!local) return <></>;

  return (
    <>
      <h4 data-testid={FormIds.mainTitle}>
        {local && local.t('forgotPassword.title')}
      </h4>
      <div className='row'>
        <div className='col s12'>
          <div className='right'>
            <button
              aria-label={local.t('forgotPassword.cancelButtonText')}
              className='btn btn-tertiary'
              onClick={() => sharedHistory.push(RouteNames.Login)}
              data-testid={FormIds.cancelBtn}
            >
              {local.t('forgotPassword.cancelButtonText')}
            </button>
            <button
              aria-label={local.t('forgotPassword.resetButtonText')}
              className='btn btn-primary'
              onClick={resetPassword}
              disabled={!formValid}
              data-testid={FormIds.resetBtn}
            >
              {local.t('forgotPassword.resetButtonText')}
            </button>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col s9'>
          <div className='row'>
            <div className='input-field col s6'>
              <input
                id={FormIds.emailInp}
                aria-label={local.t('forgotPassword.emailAddressLabel')}
                type='text'
                value={email}
                onChange={validateEmail}
                data-testid={FormIds.emailInp}
                className={emailValidation.class}
              />
              <label htmlFor={FormIds.emailInp}>
                {local.t('forgotPassword.emailAddressLabel')}
              </label>
              <span
                className='helper-text'
                data-error={emailValidation.message}
              >
                {emailValidation.message}
              </span>
              {resetPasswordErrorMessage.length > 0 ? (
                <div className='reset-error' data-testid='resetError'>
                  {resetPasswordErrorMessage}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col s9'>
            <button
              id={FormIds.resetWithCodeBtn}
              className='btn btn-tertiary'
              onClick={sendToPasswordResetWithCode}
              data-testid={FormIds.resetWithCodeBtn}
            >
              {local.t('forgotPassword.codeButtonText')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNavBar(ForgotPassword);
